// extracted by mini-css-extract-plugin
export default {"sliderButton":"SliderButton_sliderButton__4ShKN","activeBtn":"SliderButton_activeBtn__LNdV0","faq":"SliderButton_faq__WqTYi"};